module.exports = __webpack_public_path__ + "static/media/girl-17.6336ee20.svg";